<template>
  <div class="admin-home">
    <p></p>
    <h1>Bienvenido al Panel de Administración</h1>
    <p>Esta es la pantalla de inicio. Desde aquí puedes acceder a las distintas opciones de administración.</p>
  </div>
</template>

<script>
export default {
  name: "AdminHome",
};
</script>

<style scoped>
.admin-home {
  text-align: center;
  padding: 150px;
}

h1 {
  color: #29b39c;
  margin-bottom: 20px;
}

p {
  color: #555;
}
</style>
